// @flow
import styled from "styled-components";

export const DraftBarContainer = styled.div`
	display: flex;
	box-shadow: 0 2px 20px 0 rgba(0,58,49,0.30);
	background: #FFF;
	position: sticky;
	top: 0;
	z-index: 6;
`;

export default DraftBarContainer;


// WEBPACK FOOTER //
// ./src/pages/league/liveDraft/draftBarContainer.js